import { BaseDto } from '@app/_models/_DTOs/baseDto';
import { Department } from '@app/_models/_DTOs/department';
import { Employee } from '@app/_models/_DTOs/employee';
import { User } from '@app/_models/_DTOs/user';
import { AssetGroup } from '@app/_models/_DTOs/assetGroup';
import { Supplier } from '@app/_models/_DTOs/supplier';
import { AssetHistory } from '@app/_models/_DTOs/assetHistory';
import { AssetType } from '@app/_models/enums/assetType';
import { Location } from '@app/_models/_DTOs/location';
import { Media } from '@app/_models/_DTOs/media';

export class Asset extends BaseDto {
    type: AssetType;
    inventoryCode: string;
    barCode: string;
    inventoryCodeNumber: number;
    name: string;
    description: string;
    serialNumber: string;
    qty: number;
    purchasePrice: number | null;
    currentValue: number | null;
    purchaseDate: Date | string | null;
    notes: string;
    isGroupAsset: number | null;
    isActive: number | null;
    condition: number | null;
    retiredDate: Date | string | null;
    warrantyExpirationDate: Date | string | null;
    manufacturer: string;
    imageUrl: string;
    imageType: string;
    assignmentConfirmed: boolean;
    media: Media[];
    department: Department;
    employee: Employee;
    assetGroup: AssetGroup;
    location: Location;
    supplier: Supplier;
    assetHistory: AssetHistory[];
    created: Date;
    LastUpdateTime: Date;
    lastUpdatedBy: User;
    isRecommendedForDiscarding: boolean;
    discardProposalRemark: string;
}

export const AssetTypeName = new Map<AssetType, string>([
    [AssetType.OsnovnoSredstvo, "Osnovna sredstva"],
    [AssetType.SitniInventar, "Sitni inventar"]
]);